import React, { Component } from "react";
import { connect } from "react-redux";
import { func, bool } from "prop-types";
import PhoneInput from "react-phone-input-2";
import { countrySelected } from "../../logic/actions/documentCapture";
import "react-phone-input-2/lib/style.css";

import { go } from "../../logic/actions/navigation";
import { applicationCreate } from "../../logic/actions/api/application";
import PageContent from "../PageContent";
import "./style.css";
import { isMobile } from "../../logic/deviceType";
import {
  logEvent,
  STEP_COMPLETED,
  SWITCHING_TO_MOBILE,
} from "../../logic/eventLogger";
import { SENT_TO_MOBILE, VERIFICATION_CODE } from "../../logic/enums/pages";

export class PageValidatePhone extends Component {
  static propTypes = {
    applicationCreate: func,
    resend: bool,
  };

  constructor(props) {
    super(props);
    this.inputField = React.createRef();
    this.state = {
      pending: false,
      shouldProceedOnMobile: true && !isMobile(navigator.userAgent),
      isMobile: isMobile(navigator.userAgent),
    };
    this.submit.bind(this);
    this.toggleSendToMobile.bind(this);
  }

  changePhone = (primaryPhone) => {
    this.setState({ primaryPhone, error: "" });
  };

  toggleSendToMobile = (e) => {
    this.setState({ shouldProceedOnMobile: e.target.checked });
  };

  submit = (e) => {
    e.preventDefault();
    const primaryPhone = this.state.primaryPhone;
    this.props.countrySelected(this.state.country);
    if (primaryPhone) {
      const phoneNumber = primaryPhone
        .replace(/\s/g, "")
        .replace(/[{()}]|-/g, "");
      this.setState({ pending: true });
      this.props
        .applicationCreate(
          phoneNumber,
          this.state.shouldProceedOnMobile,
          this.props.resendVerificationCode.resend
        )
        .then(() => {
          logEvent(STEP_COMPLETED, { value: "phone" });
          logEvent(STEP_COMPLETED + "_phone");
          if (this.state.shouldProceedOnMobile) {
            logEvent(SWITCHING_TO_MOBILE);
            this.props.go(SENT_TO_MOBILE);
          } else {
            this.props.go(VERIFICATION_CODE);
          }
        })
        .catch((err) => {
          this.setState({
            error: err
              ? err.toString()
              : "An error has occurred. Please try again and if the problem persists, contact your support.",
            pending: false,
          });
        });
    } else {
      this.setState({ error: "Please enter valid phone number" });
    }
  };

  render() {
    return (
      <PageContent
        toggleLoading={this.state.pending}
        progressBar={true}
        progressPercentage={20}
      >
        <header />
        <h1>Validate your phone number</h1>
        <p className="center">
          Enter your phone number below so we could text you a verification
          code.
        </p>
        <label>Mobile phone</label>
        <form onSubmit={this.submit}>
          <PhoneInput
            country={
              this.props.configuration.extraConfig.featureFlags
                .phoneNumberDefault || "rs"
            }
            value={this.state.primaryPhone}
            onChange={(primaryPhone, e) => {
              this.setState({ primaryPhone, country: e.countryCode });
            }}
            inputStyle={{ width: "100%" }}
          />
          {!this.state.isMobile && (
            <label className="send-to-mobile">
              <input
                type="checkbox"
                checked={this.state.shouldProceedOnMobile}
                onChange={this.toggleSendToMobile}
              />
              <span>
                Continue onboarding on your mobile phone for better user
                experience?
              </span>
            </label>
          )}
          <p className="error">{this.state.error}</p>
          <button className="btn blue" type="submit">
            Verify phone
          </button>
        </form>
      </PageContent>
    );
  }
}

export default connect((state) => state, {
  countrySelected,
  applicationCreate,
  go,
})(PageValidatePhone);
